<style lang="less">
</style>
<template>
    <span>
        <a-popconfirm :title="$t('确定通过吗?')" @confirm="handle">
            <a :type="btnType" :disabled="submitLoading">{{ $t(text) }}</a>
        </a-popconfirm>

    </span>
</template>

<script>
import {
    completeTask,
    rejectTask,
    returnList,
    returnTask
} from "@views/flowable/api/todo";
import { deleteAction, httpAction, getAction, postAction } from '@/api/manage';
export default {
    name: 'ActPassBtn',
    components: {},
    props: {
        btnType: {
            type: String,
            default: 'link',
            required: false
        },
        /* handleType 0通过 1驳回 2退回  */
        type: {
            type: String | Number,
            default: '0',
            required: true
        },
        show:{
            type: String | Number,
            default: '0',
            required: true
        },
        dataId: {
            type: String,
            default: '',
            required: true
        },
        /*流程变量*/
        variables: {
            type: Object,
            default: () => { },
        },
        candidateUsers: {
            type: Array,
            default: () => [],
        },
        text: {
            type: String,
            default: '处理',
            required: false
        }
    },
    data() {
        return {
            handleType: {
                // 通过
                pass: 0,
                // 驳回
                back: 1,
                // 退回
                return: 2,
                // 重新提交
                reApply: 3,
                // 复合通过
                rePass: 4,

            },
            returnTaskList: [],
            candidateUsersSelecteds: [],
            modalTaskVisible: false,
            submitLoading: false,
            form: {
                comment: '',
                targetKey: ''
            },
            modalTaskTitle: '',
            url: {
                claimTaskbefore: "/task/taskTasktempitem/crewPassTest",
                statusCheck: "/task/taskTasktempitem/statusCheck", //领用前
            }
        };
    },
    created() { },
    watch: {},
    methods: {
        handle() {
            let params = {};
            params.id = this.dataId;
            if (this.show == 3) {
                //样品检测
                params.type = 3;
            } else if (this.show == 4) {
                //样品复核
                params.type = 4;
                
            } else if (this.show == 5) {
                //样品审核
                params.type = 5;
                
            }
            getAction(this.url.statusCheck, params).then((res) => {
                if (res.success) {
                    this.Classmonitor();
                } else {
                    this.$message.warning(res.message)
                    this.$emit('aleadyClaimed');
                }
            }).finally(() => {
                this.spinning = false;

            })
        },
        //班长认领
        Classmonitor() {
            this.form.comment = ''
            this.handelSubmit();
        },

        handelSubmit() {
            console.log('提交');
            this.submitLoading = true;
            var formData = Object.assign({
                dataId: this.dataId,
                candidateUsers: this.candidateUsers,
                comment: "",
                values: Object.assign({
                    dataId: this.dataId
                }, this.variables)
            }, this.form);
            console.log("formData", formData)
            console.log("type", this.type)
            // 通过
            if (this.handleType.rePass == this.type) {
                getAction(this.url.claimTaskbefore, { id: this.dataId }).then(res => {
                    if (res.code == 200) {
                        completeTask(formData).then(res => {
                            this.submitLoading = false;
                            if (res.success) {
                                this.$message.success(this.$t('操作成功'));
                                this.modalTaskVisible = false;
                                this.$emit('success');
                            } else {
                                this.$message.error(this.$t('操作失败'));
                            }
                        }).finally(() => {
                            this.submitLoading = false
                        });
                    } else if (res.code = 999) {
                        this.$message.warning(res.message)
                    }

                })
            } else {
                completeTask(formData).then(res => {
                    this.submitLoading = false;
                    if (res.success) {
                        this.$message.success(this.$t('操作成功'));
                        this.modalTaskVisible = false;
                        this.$emit('success');
                    } else {
                        this.$message.error(this.$t('操作失败'));
                    }
                }).finally(() => {
                    this.submitLoading = false
                });
            }





        },
    }
};
</script>